import * as React from "react";
import { createRoot } from "react-dom/client";
import ContentArchive from "./Components/ContentArchive";
import TileList from "./Components/TileList";

const contentArchiveContainerDOM = document.getElementsByClassName("content-archive-container")[0];
const contextDOM = document.getElementById("current-sitecore-context");
const articleListContainerDOM = document.getElementsByClassName("article-list-root")[0];

if (contentArchiveContainerDOM && contextDOM) {
    const targetFolderItemId = contentArchiveContainerDOM.getAttribute("data-targetId");
    const filterByYear = contentArchiveContainerDOM.getAttribute("data-filteryear");
    const noContentFoundText = contentArchiveContainerDOM.getAttribute("data-noContentFoundText");
    const database = contextDOM.getAttribute("data-db");
    const language = contextDOM.getAttribute("data-language");
    createRoot(contentArchiveContainerDOM).render(
        <ContentArchive
            targetId={targetFolderItemId}
            database={database}
            language={language}
            showFiltersByYear={filterByYear === "True"}
            noContentFoundText={noContentFoundText}
        />);
}

if (articleListContainerDOM) {
    const fetchCount = parseInt(articleListContainerDOM.getAttribute("data-fetchcount"), 10);
    const filterByMainCategoryList = articleListContainerDOM.getAttribute("data-filterbymaincategorylist");
    const loadmorebuttontext = articleListContainerDOM.getAttribute("data-loadmorebuttontext");
    const searchbuttontext = articleListContainerDOM.getAttribute("data-searchbuttontext");
    const clearfilterstext = articleListContainerDOM.getAttribute("data-clearfilterstext");
    const searchboxplaceholdertext = articleListContainerDOM.getAttribute("data-searchboxplaceholdertext");
    const readmoretext = articleListContainerDOM.getAttribute("data-readmoretext");
    const hideSearchField = articleListContainerDOM.getAttribute("data-hidesearchfield");
    createRoot(articleListContainerDOM).render(<TileList
        loadMoreButtonText={loadmorebuttontext}
        searchBoxPlaceholderText={searchboxplaceholdertext}
        searchButtonText={searchbuttontext}
        clearFiltersText={clearfilterstext}
        readMoreText={readmoretext}
        fetchCount={fetchCount}
        filterByMainCategoryList={filterByMainCategoryList}
        hideSearchField={hideSearchField} 
    />);
}
